var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E50571"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7148 6.17799C11.8046 5.90161 12.1956 5.90161 12.2854 6.17799L13.5045 9.92941C13.5447 10.053 13.6598 10.1367 13.7898 10.1367L17.7343 10.1368C18.0249 10.1369 18.1457 10.5087 17.9106 10.6795L14.7195 12.9982C14.6144 13.0746 14.5704 13.21 14.6106 13.3336L15.8294 17.0851C15.9191 17.3615 15.6028 17.5913 15.3677 17.4205L12.1764 15.1021C12.0713 15.0257 11.9289 15.0257 11.8238 15.1021L8.6325 17.4205C8.39739 17.5913 8.08106 17.3615 8.17086 17.0851L9.38964 13.3336C9.42979 13.21 9.3858 13.0746 9.28066 12.9982L6.08956 10.6795C5.85446 10.5087 5.97529 10.1369 6.2659 10.1368L10.2104 10.1367C10.3404 10.1367 10.4556 10.053 10.4957 9.92941L11.7148 6.17799Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStStars);
export default __webpack_public_path__ + "static/media/stSTARS.fed8495b5199130a2fec40788a71bcbb.svg";
export { ForwardRef as ReactComponent };